// Shared by the server (layout, API route) and the client (provider), so this
// file must stay free of both React and Prisma imports.

export const UPPL_COOKIE = "vektr-upplasning";
export const UPPL_ROST_STORAGE_KEY = "vektr-uppl-rost";

export const UPPL_HASTIGHET_MIN = 70;
export const UPPL_HASTIGHET_MAX = 120;
export const UPPL_HASTIGHET_DEFAULT = 90;

export interface UpplasningPref {
  pa: boolean;
  hastighet: number;
}

export const UPPL_DEFAULT: UpplasningPref = {
  pa: false,
  hastighet: UPPL_HASTIGHET_DEFAULT,
};

export function arHastighet(v: unknown): v is number {
  return (
    typeof v === "number" &&
    Number.isInteger(v) &&
    v >= UPPL_HASTIGHET_MIN &&
    v <= UPPL_HASTIGHET_MAX
  );
}

// Cookie format: "<0|1>|<hastighet>", e.g. "1|90". Kept deliberately dumb so a
// malformed value can only ever degrade to the default (off).
export function formateraUpplasningCookie(pref: UpplasningPref): string {
  return `${pref.pa ? 1 : 0}|${pref.hastighet}`;
}

export function resolveUpplasning(raw: string | null | undefined): UpplasningPref {
  if (!raw) return UPPL_DEFAULT;
  const [paRaw, hastRaw] = raw.split("|");
  const hastighet = Number.parseInt(hastRaw ?? "", 10);
  return {
    pa: paRaw === "1",
    hastighet: arHastighet(hastighet) ? hastighet : UPPL_HASTIGHET_DEFAULT,
  };
}
